const ItemGenerator = require('../../../game_items/ItemGenerator');
const Staff = require('../../../game_items/equipment/weapon/Staff');
const MedBoots = require('../../../game_items/equipment/boots/MedBoots.js');
const MedHelmet = require('../../../game_items/equipment/helmet/MedHelmet.js');
const MedTorsoe = require('../../../game_items/equipment/torsoe/MedTorsoe.js');
const getMobEquipmenAssignmentFromBags = require('../mobs/getMobEquipmenAssignmentFromBags');

const fire_drake = (level) => {
  const handle = 'fire_drake';
  const types = ['beast', 'flying', 'magic', 'reptile'];
  const AI_PRIORITIES = ['dps_close', 'interference', 'tank', 'support', 'dps_ranged'];
  const equipped_abilities = [
    { value: 'move' },
    { value: 'melee_attack' },
    { value: 'burning_hands' },
    { value: 'leap' },
    { value: 'preparation' },
    { value: 'sky_hammer' },
  ];
  const bags = [
    {
      value: {
        items: [
          ItemGenerator.getCavernsMobItem(Staff, level),
          ItemGenerator.getCavernsMobItem(MedBoots, level),
          ItemGenerator.getCavernsMobItem(MedHelmet, level),
          ItemGenerator.getCavernsMobItem(MedTorsoe, level),
        ].map((item) => ({ value: item })),
      },
    },
  ];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'fire_drake_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          burning_hands: {
            handle: 'burning_hands',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          leap: {
            handle: 'leap',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          preparation: {
            handle: 'preparation',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          sky_hammer: {
            handle: 'sky_hammer',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          quickness: {
            handle: 'quickness',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
            passive: true,
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(3 + bound_level * 0.5 + Math.random() * 3),
      perception: Math.round(2 + bound_level * 0.35 + Math.random() * 3),
      mana: Math.round(3 + bound_level * 0.65 + Math.random() * 3),
      toughness: Math.round(3 + bound_level * 0.45 + Math.random() * 3),
      strength: Math.round(3 + bound_level * 0.4 + Math.random() * 3),
      willpower: Math.round(3 + bound_level * 0.4 + Math.random() * 3),
      dexterity: Math.round(4 + bound_level * 0.9 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => AI_PRIORITIES,
    xpValue: level * 150,
    drops_gold: true,
    drops_equipment: false,
    bags,
    build: {
      ai: {
        priorities: AI_PRIORITIES,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: getMobEquipmenAssignmentFromBags(bags),
      equipped_abilities,
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = fire_drake;
